import React, { useContext } from 'react';
import { I18n } from '@aws-amplify/core';
import { useHistory } from 'react-router-dom';

import { ReportTemplate } from '@/components/views/Report/ReportTemplate';
import Spinner from '@/components/Layout/Spinner';
import { Charts } from './Charts';

import { useSectors } from '../hooks';
import { AngleTimeContext } from '../context';
import { useApplicationContext } from '@/context/v1/Application/context';

export const Result = ({ form, angles, settings, isLoadingPDF, onDownloadPDF, onChangeComment }) => {
	const history = useHistory();
	const { isSandbox, sendReport, existsReport } = useApplicationContext();

	const { organizationId, companyId, file, riskRangeName, riskRangeId } = useContext(AngleTimeContext);
	const sectors = useSectors(organizationId, companyId);
	const selectedSector = sectors.data?.find((sector) => sector.id === file.data.sector_id);

	const exists = existsReport({
		file_id: file.data.id,
		company_id: companyId,
		organization_id: organizationId,
		report_type: 'ANGLE_TIME'
	});

	function handleSendReport() {
		const request = {
			report_type: 'ANGLE_TIME',
			id: riskRangeId || '',
			company_id: companyId,
			organization_id: organizationId
		};

		const currentPath = history.location.pathname;
		const cleanPath = currentPath.match(/(\/reporting\/angle-time)/)?.[1];

		if (cleanPath && currentPath !== cleanPath) {
			history.push(cleanPath);
		}
		sendReport(request);
	}

	const sections = [
		{
			title: I18n.get('Charts'),
			component: <Charts angles={angles.data} settings={settings.data} />
		}
	];

	const isLoading = angles.isLoading || settings.isLoading;

	if (isLoading) {
		return <Spinner />;
	}

	return (
		<ReportTemplate
			title={I18n.get('Report Results - Angle by Time')}
			isLoading={false}
			sections={sections}
			fileData={{ ...file?.data, riskRangeName }}
			sector={selectedSector}
			isLoadingPDF={isLoadingPDF}
			onDownloadPDF={onDownloadPDF}
			onChangeComment={onChangeComment}
			reportData={{ collection_date: form.getFieldValue('collection_date') }}
			exists={exists}
			handleSendReport={handleSendReport}
		/>
	);
};
